import React, {useCallback} from 'react'
import {useTranslation} from 'react-i18next'
import {TitledBody} from '../common/components/TitledBody'
import {FlowForm} from './FlowForm'
import {AnswerGroupForm, Language} from '../app/types'
import {api} from '../common/api'
import {useSelector} from 'react-redux'
import {defaultNcosSelector, selectedSiteSelector} from '../authentication/redux'
import {useHistory} from 'react-router'
import {useFormSubmissionButtons} from "../common/form/useFormSubmissmionButtons";
import CancelButton from "../common/form/CancelButton";
import {Grid} from "@mui/material";

const initialPremiumCallCenter = (defaultNcos: string): AnswerGroupForm => ({
    answerGroupType: 'QUEUE',
    uuid: '',
    name: '',
    language: Language.nl,
    extension: '',
    number: '',
    voicemailEmail: '',
    additionalVoicemailEmails: '',
    userAgents: [],
    agentRingTime: 12,
    huntPolicy: 'CIRCULAR',
    overflowDestination: 'VOICEMAIL',
    overflowNumber: '',
    overflowAnnouncementFileName: '',
    webexLogin: false,
    welcomeMessageFileName: '',
    musicOnHoldFileName: '',
    comfortMessageFileName: '',
    comfortMessageGapTime: 60,
    queueLength: 20,
    forwardTimeoutSeconds: null,
    overflowTimeout: 120,
    allowAgentLogoff: true,
    allowCallWaitingForAgents: true,
    voicemailNoAnswerAnnouncement: '##DEFAULT_TELENET##',
    callForwardAnnouncement: '',
    ncos: defaultNcos,
    voicemailUsage: 'FORWARD_TO_EMAIL',
    nightServiceMode: 'USE_GROUP',
    ringPatternForExternalCalls: 'NORMAL',
    playRingingWhenOfferingCall: false,
    hideFromPhoneBook: false,

    premiumCallCenter: true,
    positionInQueueMessageEnabled: false,
    positionInQueueMessageInterval: 20,
    agentStateAfterCall: 'NOT_SET',
    wrapupTimer: false,
    maxWrapUpTimeAfterCall: 60,
    cdcstate: 'DISABLED',
    defaultCDC: null,
    defaultCDCId: null,
    unavailableCode: null,
    unavailableCodeId: null,
    agentsSignedOutStrandedCallAction: 'NOTHING',
    agentsSignedOutStrandedCallTransferNumber : '',
    agentsSignedOutStrandedCallAnnouncement: null,
    agentsUnavailableStrandedCallAction: 'NOTHING',
    agentsUnavailableStrandedCallTransferNumber: '',
    agentsUnavailableStrandedCallAnnouncement: null,
    skilledAgent1Users: [],
    skilledAgent6Users: [],
    skilledAgent11Users: [],
    supervisors: [],
})

export const AddPremiumCallCenter = () => {
    const { t } = useTranslation()
    const site = useSelector(selectedSiteSelector)
    const history = useHistory()
    const defaultNcos = useSelector(defaultNcosSelector)
    const {buildFormButtons} = useFormSubmissionButtons(true)

    const onSubmit = useCallback(
        async (formData: AnswerGroupForm) => {
            if (!site) return
            await api.post(`/api/site/${site.productId}/answergroup`, {
                ...formData,
                agentUserIds: formData.userAgents?.map(agent => agent.uuid).join(','),
                maxWrapUpTimeAfterCall: formData.wrapupTimer ? formData.maxWrapUpTimeAfterCall : null,
                positionInQueueMessageInterval: formData.positionInQueueMessageEnabled ? formData.positionInQueueMessageInterval : null,
                defaultCDCId: formData.cdcstate === 'FORCE' ? formData.defaultCDCId : null,
                supervisorUserIds: formData.supervisors?.map(agent => agent.uuid),
                skilledAgent1UserIds: formData.skilledAgent1Users?.map(agent => agent.uuid),
                skilledAgent6UserIds: formData.skilledAgent6Users?.map(agent => agent.uuid),
                skilledAgent11UserIds: formData.skilledAgent11Users?.map(agent => agent.uuid),
            })
            history.push('/flows')
        },
        [site, history]
    )

    return (
        <TitledBody title={t('flows.add-premium-callcenter.title')}>
            <Grid container>
                <Grid item xs={12} lg={9}>
                    <FlowForm onSubmit={onSubmit} flow={initialPremiumCallCenter(defaultNcos)} buildFormButtons={buildFormButtons(<CancelButton />)}/>
                </Grid>
            </Grid>
        </TitledBody>
    )
}
